"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_query_1 = require("react-query");
var queryClient = new react_query_1.QueryClient();
exports.default = queryClient;
